module.exports = __webpack_public_path__ + "static/media/snky.2f51a888.svg";